import ProgressIndicator from '../progress-indicator/ProgressIndicator';

export default function ProgressBanner({children = null}) {
    return (
        <div style={{padding: 10}}>
            <ProgressIndicator />
            {children}
        </div>
    );
}